module.exports = __webpack_public_path__ + "static/media/forward.16bbd97a.svg";